import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "react-day-picker/dist/style.css";

// Suppress known harmless console warnings/errors
const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  // Suppress OpaqueResponseBlocking warnings (Google Maps iframe)
  if (message.includes('OpaqueResponseBlocking')) {
    return;
  }
  // Suppress cookie domain warnings (Cloudflare, Google Maps)
  if (message.includes('Cookie') && (message.includes('rejected for invalid domain') || message.includes('_cf_bm'))) {
    return;
  }
  // Suppress Content-Security-Policy warnings
  if (message.includes('Content-Security-Policy')) {
    return;
  }
  // Suppress favicon 404 errors
  if (message.includes('favicon') || args.some(arg => typeof arg === 'string' && arg.includes('favicon'))) {
    return;
  }
  // Suppress broken image errors (handled by error handlers)
  if (message.includes('Failed to load resource') && (message.includes('.jpg') || message.includes('.png'))) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  // Suppress OpaqueResponseBlocking warnings
  if (message.includes('OpaqueResponseBlocking')) {
    return;
  }
  // Suppress cookie domain warnings
  if (message.includes('Cookie') && (message.includes('rejected for invalid domain') || message.includes('_cf_bm'))) {
    return;
  }
  // Suppress Content-Security-Policy warnings
  if (message.includes('Content-Security-Policy')) {
    return;
  }
  // Suppress partitioned cookie warnings (Google Maps)
  if (message.includes('Partitioned cookie') || message.includes('dynamic state partitioning')) {
    return;
  }
  // Suppress "Search endpoint requested!" informational messages
  if (message.includes('Search endpoint requested')) {
    return;
  }
  originalWarn.apply(console, args);
};

createRoot(document.getElementById("root")!).render(<App />);
